var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediumLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.41 12c0 3.314-2.779 6-6.205 6C3.778 18 1 15.313 1 12s2.778-6 6.205-6 6.204 2.686 6.204 6zM20.216 12c0 3.119-1.389 5.649-3.102 5.649-1.713 0-3.102-2.53-3.102-5.65 0-3.118 1.388-5.648 3.102-5.648 1.713 0 3.102 2.529 3.102 5.649M23 12c0 2.794-.488 5.06-1.09 5.06-.603 0-1.092-2.265-1.092-5.06 0-2.795.489-5.06 1.091-5.06C22.512 6.94 23 9.205 23 12z",
    fill: "currentColor"
  })));
}
export default SvgMediumLogo;